<!--
 * @Descripttion: 
 * @version: v1.0.0
 * @Author: zhoumin
 * @Date: 2020-08-22 15:50:13
 * @LastEditors: zhoumin
 * @LastEditTime: 2020-09-23 18:09:35
-->
<template>
  <div class="">
    <p class='count'>
      <span>报名数：{{totalSchool}}</span>
      <!-- <span>项目组数：{{totalProject}}</span> -->
    </p>
    <section class="filter">
      <div class="filter_btn">
        <span class="config" @click="dialogVisible = true" v-if="identify==='3'">参赛设置 <i class="el-icon-setting"></i></span>
        <span class="export_excel" @click="exportProject">申报表导出 <i class="el-icon-download"></i></span>
      </div>
      <p>
        <span v-for="(item, i) in status" :key="item.key" :class="{ actived: item.key === activedStatus.key }" @click="changeStatus(item)">{{ item.key }}</span>
      </p>
      <p>
        <!-- <label for="">院校类型：</label> -->
        <span v-for="(item, i) in types" :key="item.key" :class="{ actived: item.key === activedType.key }" @click="changeType(item)">{{ item.key }}</span>
        <el-input v-model="params.keyword" placeholder="请输入关键字" @change="getList"  suffix-icon="el-icon-search"></el-input>
      </p>
    </section>
    <main>
      <el-table :data="tableData" style="width: 100%" header-row-class-name="project" header-align="center">
        <el-table-column type="index" label="序号" width="80" align="center" key="index">
        </el-table-column>
        <el-table-column prop="applySchool" label="参赛学校" align="center" key="applySchool">
        </el-table-column>
        <el-table-column prop="name" label="参赛人" align="center" key="name"></el-table-column>
        <el-table-column v-if='params.status === 1' prop="currentStatusDesc" label="状态" align="center" key="currentStatusDesc"></el-table-column>
        <el-table-column v-if='params.status === 1' prop="checkUserName" label="审核人" align="center" key="checkUserName">
          <template slot-scope="scope">{{(scope.row.checkList && scope.row.checkList.length>0) ? scope.row.checkList[0].userName:'-'}}</template>
        </el-table-column>
        <el-table-column v-if='params.status === 1' prop="checkTime" label="审核时间" align="center" key="checkTime">
          <template slot-scope="scope">{{(scope.row.checkList && scope.row.checkList.length>0) ? scope.row.checkList[0].checkTime:'-'}}</template>
        </el-table-column>
        <el-table-column v-if='params.status === 1' prop="checkDesc" label="备注" align="center" key="checkDesc">
          <template slot-scope="scope">{{(scope.row.checkList && scope.row.checkList.length>0) ? scope.row.checkList[0].checkDesc:'-'}}</template>
        </el-table-column>
        <el-table-column label="操作" width="240" align="center">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row, false)" round type="primary" size="medium"> 查看 </el-button>
            <el-button @click="handleEdit(scope.row)" round type="primary" size="medium" v-if="identify !== '3'">{{params.status === 1 ?'重新审核':'审核'}} </el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :pageSize.sync='pageSize' :currentPage.sync='currentPage' :total.sync='total' class='Pagination'></Pagination>
    </main>
    <el-dialog title="参赛设置" :visible.sync="dialogVisible" width="550px" class='config_dialog' :close-on-click-modal='false'>
      <div>
        <h4>报名时间：</h4>
        <div>
          <el-radio-group v-model="config.projectEnterType">
            <p>
              <el-radio :label="0">
                <label for="" class="config_label">按时间设置</label>
                <el-date-picker type="datetimerange" :disabled="config.projectEnterType===1" v-model="date" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-radio>
            </p>
            <p>
              <el-radio :label="1">
                <label for="" class="config_label">手动设置</label>
                <el-switch :disabled="config.projectEnterType===0" v-model="config.isProjectEnter" active-color="#13ce66" inactive-color="#ff4949" :active-value="0" :inactive-value="1">
                </el-switch>
              </el-radio>
            </p>
          </el-radio-group>
          <!-- <p>自动审核：同一学校报名最大数 <el-input-number v-model="config.schoolMaxNum" :min="1" :max="10" label="描述文字" size="mini"></el-input-number></p> -->
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setConfig" round>确 定</el-button>
        <el-button @click="dialogVisible = false" round>取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="isEdit?'审核':'查看'" :visible.sync="checkVisible" width="550px" class='config_dialog' :close-on-click-modal='false'>
      <BasicInfo :info='checkItem'></BasicInfo>
      <el-divider></el-divider>
      <div class="records">
        <h5>审核记录</h5>
        <ul :class="[show ? 'show': 'hide']" v-if="checkItem.checkList&&checkItem.checkList.length>0">
          <li v-for="(i, index) in checkItem.checkList" :key="index"><span>{{i.checkTime}}</span><span>{{i.userName}}审核</span><span>{{i.result | toName}}</span>
            <div>备注：{{i.checkDesc}}</div>
          </li>
        </ul>
        <div>
          <el-tooltip class="item" effect="dark" :content="show?'折叠':'打开'" placement="bottom">
            <i :class="[show ? 'el-icon-arrow-up': 'el-icon-arrow-down']" @click="show = !show"></i>
          </el-tooltip>
        </div>
      </div>
      <el-divider></el-divider>
      <div v-show="isEdit">
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="申报审核：" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="form.desc">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="isEdit" type="primary" @click="checkProject" round>提交</el-button>
        <el-button v-else type="primary" @click="checkVisible=false" round>确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination/Pagination";
import BasicInfo from "@/src/components/BasicInfo";
import {
  $getList,
  $getDetail,
  $getStatistics,
  $checkProject,
  $exportProject
} from "../../api/activity/two/compete/manage.js";
import {
  $setConfig,
  $getConfig
} from "../../api/activity/two/config/manage.js";
export default {
  name: "",
  components: {
    Pagination,
    BasicInfo
  },
  filters: {
    toName(i) {
      const obj = {
        0: "待审核",
        1: "通过",
        2: "驳回"
      };
      return obj[i];
    }
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      total: 200,
      status: [
        { key: "待审核", value: 0 },
        { key: "已审核", value: 1 }
      ],
      types: [],
      activedType: {},
      activedStatus: { key: "待审核", value: 0 },
      dialogVisible: false,
      tableData: [],
      radio: 1,
      params: {
        page: 1,
        rows: 10,
        group: 2,
        keyword: "",
        type: 1,
        status: 0
      },
      date: [],
      totalSchool: 0,
      totalProject: 0,
      value: false,
      num: 1,
      checkItem: {},
      form: {
        status: 1
      },
      config: {
        projectEnterType: 0,
        isProjectEnter: 1,
        schoolMaxNum: 3
      },
      checkVisible: false,
      isEdit: true,
      show: false,
      identify: ""
    };
  },
  watch: {
    pageSize() {
      this.params.rows = this.pageSize;
      if (
        this.currentPage !== 1 &&
        this.total / this.pageSize < this.currentPage
      ) {
        return;
      }
      this.getList();
    },
    currentPage() {
      this.params.page = this.currentPage;
      this.getList();
    },
    checkVisible() {
      if (!this.checkVisible) {
        this.show = false;
        this.form = {
          status: 1
        };
      }
    }
  },
  methods: {
    changeStatus(item) {
      this.activedStatus = item;
      this.params.status = item.value;
      this.getList();
    },
    changeType(item) {
      this.activedType = item;
      this.params.group = item.value;
      this.getList();
    },
    getList() {
      this.tableData = [];
      $getList(this.params).then(
        res => {
          this.total = res.totalSize;
          this.tableData = res.resultList;
        },
        res => {
          if (res.statusDesc === "您无该功能权限，请联系管理员") {
            setTimeout(() => {
              this.$router.push({ name: "Home" });
            }, 100);
          }
        }
      );
    },
    handleEdit(item, isEdit = true) {
      this.isEdit = isEdit;
      $getDetail({ id: item.id }).then(res => {
        this.checkVisible = true;
        this.checkItem = res;
      });
    },
    getStatistics() {
      $getStatistics({ type: 1 }).then(res => {
        this.totalSchool = res.totalSchool;
        this.totalProject = res.totalProject;
      });
    },
    checkProject() {
      this.form.id = this.checkItem.id;
      $checkProject(this.form).then(res => {
        this.$notify({
          title: "成功",
          message: "审核成功",
          type: "success"
        });
        this.checkVisible = false;
        this.getList();
      });
    },
    setConfig() {
      const config = Object.assign({}, this.config);
      if (this.config.projectEnterType === 0) {
        config.projectEnterStartTime = this.date[0];
        config.projectEnterEndTime = this.date[1];
      }
      $setConfig(config).then(res => {
        this.$notify({
          title: "成功",
          message: "设置成功",
          type: "success"
        });
        this.dialogVisible = false;
      });
    },
    download(item) {
      this.$utils.downloadFile(item.name, item.desc);
    },
    getConfig() {
      $getConfig().then(res => {
        this.date = [res.projectEnterStartTime, res.projectEnterEndTime];
        this.config = res;
      });
    },
    exportProject() {
      $exportProject().then(res => {
        const a = {
          name: res.fileName,
          desc: "申报列表"
        };
        this.download(a);
      });
    }
  },
  created() {
    this.types = this.$enumsFront.ENUM_GROUP_TYPE_ALL;
    this.identify = localStorage.identify;
    this.activedType = this.types[0];
    this.getStatistics();
    this.getConfig();
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.count {
  width: 438px;
  background: rgba(255, 235, 227, 1);
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 41px;
  margin: 0 auto;
  font-size: 22px;
  font-weight: bold;
  line-height: 55px;
  color: rgba(235, 85, 79, 1);
  text-align: center;
  span + span {
    margin-left: 40px;
  }
}
.filter {
  color: rgba(102, 102, 102, 1);
  line-height: 44px;
  p:nth-of-type(1) {
    text-align: center;
  }
  p:nth-of-type(2) {
    text-align: left;
    font-size: 20px;
    .el-input {
      float: right;
      width: 394px;
      height: 40px;
      /deep/.el-input__inner {
        border-radius: 20px;
      }
    }
  }
  label {
    margin-right: 20px;
  }
  span {
    cursor: pointer;
  }
  span.actived {
    color: rgba(235, 85, 79, 1);
    font-weight: bold;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      width: 38px;
      height: 4px;
      background: rgba(235, 85, 79, 1);
      opacity: 1;
      border-radius: 275px;
      bottom: -5px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  span + span {
    margin-left: 30px;
  }
  .filter_btn {
    text-align: right;
    .config {
      // position: absolute;
      // right: 0;
      font-size: 22px;
      color: rgba(235, 85, 79, 1);
    }
    .export_excel {
      // position: absolute;
      // right: 160px;
      font-size: 22px;
      color: rgba(235, 85, 79, 1);
    }
  }
}
.config_dialog {
  /deep/ .el-dialog__header {
    background: rgba(248, 248, 248, 1);
    line-height: 50px;
    padding-left: 20px;
    color: #333333;
    .el-dialog__title {
      line-height: 50px;
    }
  }
  /deep/ .el-dialog__body {
    max-height: 900px;
    overflow: auto;
    h4 {
      color: #666666;
      font-size: 16px;
      font-weight: 400;
      margin-block-start: 0;
      margin-block-end: 0;
    }
    .el-input-number {
      margin-left: 30px;
    }
    .el-radio-group {
      p {
        margin-bottom: 20px;
        display: flex;
      }
    }
  }
  .dialog-footer {
    text-align: center;
  }
}
.Pagination {
  margin: 20px 0;
}

.records {
  .hide {
    height: 1.4em;
    overflow: hidden;
  }
  .show {
    overflow: visible;
  }
  li {
    span {
      margin-right: 30px;
    }
    div {
      line-height: 1.6;
    }
    margin-bottom: 10px;
  }
  > div {
    text-align: center;
    i {
      padding: 0px 50px;
      cursor: pointer;
      font-size: 20px;
    }
  }
}
label.config_label {
  padding-right: 10px;
}
</style>